import actionTypes from '../../action-types'

export default (payload, meta, included) => ({
  type: actionTypes.IMPORTERS.SET_ALL,
  payload,
  meta,
  included,
})
